import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import {
  ContentWrapper,
  Details,
  SubHeading,
} from '~/components/compositional/DetailViewStyles'
import { Input, Text } from '~/components/core'
import { FontStyle } from '~/components/core/Text'
import { MangoButtonVariant } from '~/components/shared/componentStyles/MangoButton.style'
import { MangoButton } from '~/components/shared/MangoButton'
import { light, spacing } from '~/constants/theme'

import { MessageGroup, MessageThread } from '@mangovoice/types'

import Thread from './Thread'

const EditThreadNameWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`

const RenameButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 ${spacing.spacingXL};
  gap: ${spacing.spacingMD};
`

interface MessageThreadHeaderProps {
  currentThreadName: string
  messageGroupName?: string
  subheadingText: string
  isEditing: boolean
  newThreadName?: string
  onChangeThreadName: (newThreadName: string) => void
  onSubmitNewThreadName: () => void
  onCancelEdit: () => void
}
export const MessageThreadHeader = ({
  currentThreadName,
  messageGroupName,
  subheadingText,
  isEditing,
  newThreadName,
  onChangeThreadName,
  onSubmitNewThreadName,
  onCancelEdit,
}: MessageThreadHeaderProps) => {
  const { t } = useTranslation()
  return (
    <>
      {isEditing ? (
        <EditThreadNameWrapper>
          <Input
            // @ts-expect-error TODO: fix this
            value={newThreadName}
            onChange={onChangeThreadName}
            onKeyDown={({ keyCode }) => {
              if (keyCode === 13) {
                onSubmitNewThreadName()
              }
            }}
            autoFocus
          />
          <RenameButtonsWrapper>
            <MangoButton
              disabled={
                newThreadName === currentThreadName || newThreadName === ''
              }
              onClick={() => {
                onSubmitNewThreadName()
              }}
            >
              {t('messageThreadHeader.rename')}
            </MangoButton>
            <MangoButton
              variant={MangoButtonVariant.Default_100}
              onClick={onCancelEdit}
            >
              {t('messageThreadHeader.cancel')}
            </MangoButton>
          </RenameButtonsWrapper>
        </EditThreadNameWrapper>
      ) : (
        <Details>
          <Text
            fontStyle={FontStyle.MediumBold}
            style={{
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
            }}
            text={currentThreadName}
            color={light.dark900}
          />
          <SubHeading>
            <Text
              fontStyle={FontStyle.Small}
              text={subheadingText}
              color={light.dark800}
            />
            {messageGroupName && (
              <Text
                fontStyle={FontStyle.Small}
                text={messageGroupName}
                color={light.primary}
                weight="600"
                style={{ marginLeft: 5 }}
              />
            )}
          </SubHeading>
        </Details>
      )}
    </>
  )
}

interface MessageThreadViewProps {
  currentThread: MessageThread
  messageGroup?: MessageGroup
}
const MessageThreadView = ({ currentThread }: MessageThreadViewProps) => {
  const memoizedThread = useMemo(() => {
    return <Thread currentThread={currentThread} key={currentThread.id} />
  }, [currentThread.id])

  return <ContentWrapper>{memoizedThread}</ContentWrapper>
}

export default MessageThreadView
